export default "__VITE_ASSET__9o3jcy8y__"